import React, { useContext, useEffect, useState } from 'react';
import './workflowEditor.css';

import { getTenantWorkflowById } from '../../services/api-calls';
import { buildSelectionAttributes } from '../../services/utils';

import { Map as ImmutableMap } from 'immutable';
import { TenantIdContext } from '../../../../components/app/App';
import { WorkflowGraph } from './workflow-graph';
import { useHistory } from 'react-router';
import { Header } from '../header/Header';
import { WorkflowDisplay } from './WorkflowDisplay';

export const WorkflowViewer = ({ match }) => {
  const tenantId = useContext(TenantIdContext);
  const [workflowGraphs, setWorkflowGraphs] = useState([]);

  const [workflowData, setWorkflowData] = useState(null);
  const [workflowSelectionAttributes, setWorkflowSelectionAttributes] = useState(new ImmutableMap());
  const [loadedTenantId, setLoadedTenantId] = useState('');
  const history = useHistory();

  useEffect(() => {
    if (loadedTenantId && loadedTenantId !== tenantId) {
      return;
    }
    getTenantWorkflowById(tenantId, match.params.id).then(response => {
      const workflowFromResponse = response?.data;
      if (!workflowFromResponse || !workflowFromResponse?.workflowId || !workflowFromResponse?.workflowName) {
        history.push('/workflows');
      }
      setWorkflowSelectionAttributes(buildSelectionAttributes(workflowFromResponse?.selectorAttributes));
      setWorkflowData(workflowFromResponse);
      setLoadedTenantId(tenantId);
    });
  }, [match, tenantId, history, loadedTenantId]);

  useEffect(() => {
    if (!workflowData || !workflowData.subWorkflows) {
      return;
    }
    setWorkflowGraphs(
      workflowData.subWorkflows.map(subWorkflow => {
        return new WorkflowGraph(subWorkflow);
      })
    );
  }, [workflowData]);

  return (
    <div className="w-100 h-100 p-1 d-flex flex-column">
      <Header workflowData={workflowData} currentPage="live" />
      <WorkflowDisplay
        workflowData={workflowData}
        workflowGraphs={workflowGraphs}
        workflowSelectionAttributes={workflowSelectionAttributes}
      />
    </div>
  );
};

export default WorkflowViewer;
